import {Injectable} from '@angular/core';
import {  Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { AuthHttp } from '../../core/auth-http.service';


@Injectable()
export class InquiryService {

  constructor(private http: AuthHttp) {}

    // TODO change api to 'ord/travel/inquiry'
    sendDataToApi(data) {
      return this.http.post('order/travel/inquiry', data)
      .map((response: Response) => response.json());
    }

    // TODO change api to 'ord/travel/inquiry'
    sendInquiryData(data) {
      return this.http.post('order/travel/inquiry', data)
      .map((response: Response) => response.json());
    }

    getPrdViewTravel(id) {
      return this.http.get('prd/travel/view/' + id)
      .map((response: Response) => response.json());
    }

}



// WEBPACK FOOTER //
// ./src/app/details/inquiry/inquiry.servvice.ts